import React, { useContext } from 'react';
import {PageTitle} from '@/_metronic/layout/core'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder';
import PageTable from './components/PageTable';

const Breadcrumbs = BreadcrumbsBuilder([
  { title: 'Home',  path: '/' },
  { title: 'Analytics',  path: '/analytics/overview' },
]);

const PageReportPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>Pages report</PageTitle>
      <PageTable />
    </>
  );
}

export default PageReportPage;
